
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C114.625 0 0 114.625 0 256s114.625 256 256 256c141.406 0 256-114.625 256-256S397.406 0 256 0zm69.812 354.844c-12.594 14.125-30.78 22.438-54.562 24.938V416h-30.313v-36.031c-39.656-4.062-64.188-27.125-73.656-69.125l46.875-12.219c4.344 26.406 18.719 39.594 43.125 39.594 11.406 0 19.844-2.812 25.219-8.469s8.062-12.469 8.062-20.469c0-8.281-2.688-14.563-8.062-18.813-5.375-4.28-17.344-9.688-35.875-16.25-16.656-5.78-29.688-11.469-39.063-17.155-9.375-5.625-17-13.531-22.844-23.688-5.844-10.188-8.781-22.063-8.781-35.563 0-17.719 5.25-33.688 15.688-47.875 10.438-14.156 26.875-22.813 49.313-25.969V96h30.313v27.969c33.875 4.063 55.813 23.219 65.781 57.5l-41.75 17.125c-8.156-23.5-20.72-35.25-37.781-35.25-8.563 0-15.438 2.625-20.594 7.875-5.188 5.25-7.781 11.625-7.781 19.094 0 7.625 2.5 13.469 7.5 17.563 4.969 4.063 15.688 9.094 32.063 15.125 18 6.563 32.125 12.781 42.344 18.625 10.25 5.844 18.406 13.938 24.531 24.219 6.094 10.313 9.155 22.345 9.155 36.126 0 21.154-6.313 38.779-18.907 52.873z"}})])
          )
        }
      }
    